export default __webpack_public_path__ + "static/media/iconBadge.65e461ca.svg";